import isEmpty from "lodash/isEmpty";
import {ListGroup} from "react-bootstrap";
import Link from "next/link";
import Image from "next/image";
import {Icon} from "semantic-ui-react";
import {timeSince} from "../utilities/utils";
import React from "react";


const RelatedPosts = ({relatedPosts, searchTerm = null}) => {
    return (
        <ListGroup>
            {isEmpty(relatedPosts) && <div className={'text-center'}>
                No results for {searchTerm}
            </div>}
            {!isEmpty(relatedPosts) && relatedPosts.map(post =>
                <ListGroup.Item className={'p-2'} key={post['id']}>
                    <Link href="/p/[id]" as={`/p/${post['id']}`}>
                        <div className={
                            'd-flex flex-row'
                        }>
                            <div style={{height: 90, position: 'relative', flex: '0 0 90px'}}
                                 className={"align-self-center"}>
                                <Image
                                    layout={"fill"}
                                    src={post['thumbnail']}
                                    className={'rounded'}
                                    alt="thumbnail"
                                    // style={isGraphicOrProfane ? {filter: 'blur(2px)'} : null}
                                    blurDataURL="data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWEREiMxUf/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q=="
                                    placeholder={"blur"}
                                />
                                {
                                    (!isEmpty(post['youtubeIds']) || Boolean(post['video'])) &&
                                    <Icon name={'play'} color={'red'} inverted style={{
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                    }} bordered size={'tiny'}/>
                                }
                            </div>
                            <div className={'ml-3 align-self-center text-left'}>
                                <h6>
                                    {post['title']}
                                </h6>
                                <small className={'text-secondary'}>
                                    {timeSince(post['timeStamp'])}
                                </small>
                            </div>
                        </div>
                    </Link>
                </ListGroup.Item>
            )}
        </ListGroup>
    )
}

export default RelatedPosts